<div [ngClass]="parentClass">
  <label class="bot-flag">
    <i class="fas fa-robot mr-1"></i>
    <span class="ml-1" translate>Bot</span>
  </label>
</div>
